var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.037 2.64166C7.27867 2.64166 5.037 4.88333 5.037 7.64166V10.05C5.037 10.5583 4.82034 11.3333 4.562 11.7667L3.60367 13.3583C3.012 14.3417 3.42034 15.4333 4.50367 15.8C8.09534 17 11.9703 17 15.562 15.8C16.5703 15.4667 17.012 14.275 16.462 13.3583L15.5037 11.7667C15.2537 11.3333 15.037 10.5583 15.037 10.05V7.64166C15.037 4.89166 12.787 2.64166 10.037 2.64166Z",
    stroke: "#0082CD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5794 2.88331C11.3211 2.80831 11.0544 2.74998 10.7794 2.71665C9.97943 2.61665 9.21276 2.67498 8.49609 2.88331C8.73776 2.26665 9.33776 1.83331 10.0378 1.83331C10.7378 1.83331 11.3378 2.26665 11.5794 2.88331Z",
    stroke: "#0082CD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5352 16.9333C12.5352 18.3083 11.4102 19.4333 10.0352 19.4333C9.35182 19.4333 8.71849 19.15 8.26849 18.7C7.81849 18.25 7.53516 17.6166 7.53516 16.9333",
    stroke: "#0082CD",
    strokeWidth: 1.8,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a5a251b77fcf388acda2d257bdace684.svg";
export { ForwardRef as ReactComponent };